"use client";

import React, { useState, useEffect } from "react";

import * as Icon from "@phosphor-icons/react/dist/ssr";
import { useLocation } from "react-router-dom";
import Product from "../../../components/Product/Product";
import productData from "../../../data/Product.json";
import useLoginPopup from "../../../store/useLoginPopup";
import useMenuMobile from "../../../store/useMenuMobile";
import { useModalCartContext } from "../../../context/ModalCartContext";
import { useModalWishlistContext } from "../../../context/ModalWishlistContext";
import { useModalSearchContext } from "../../../context/ModalSearchContext";
import { useCart } from "../../../context/CartContext";
import { useNavigate } from "react-router-dom";

interface Props {
  props: string;
}

const MenuOne: React.FC<Props> = ({ props }) => {
  const router = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  let [selectedType, setSelectedType] = useState<string | null>();
  const { openLoginPopup, handleLoginPopup } = useLoginPopup();
  const { openMenuMobile, handleMenuMobile } = useMenuMobile();
  const [openSubNavMobile, setOpenSubNavMobile] = useState<number | null>(null);
  const { openModalCart } = useModalCartContext();
  const { cartState } = useCart();
  const { openModalWishlist } = useModalWishlistContext();
  const { openModalSearch } = useModalSearchContext();

  const handleOpenSubNavMobile = (index: number) => {
    setOpenSubNavMobile(openSubNavMobile === index ? null : index);
  };

  const [fixedHeader, setFixedHeader] = useState(false);
  const [lastScrollPosition, setLastScrollPosition] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setFixedHeader(scrollPosition > 0 && scrollPosition < lastScrollPosition);
      setLastScrollPosition(scrollPosition);
    };

    // Gắn sự kiện cuộn khi component được mount
    window.addEventListener("scroll", handleScroll);

    // Hủy sự kiện khi component bị unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollPosition]);

  const handleGenderClick = (gender: string) => {
    router(`/shop/breadcrumb1?gender=${gender}`);
  };

  const handleCategoryClick = (category: string) => {
    router(`/shop/breadcrumb1?category=${category}`);
  };

  const handleTypeClick = (type: string) => {
    setSelectedType(type);
    router(`/shop/breadcrumb1?type=${type}`);
  };

  return (
    <>
      <div
        className={`header-menu style-one ${
          fixedHeader ? "fixed" : "absolute"
        } top-0 left-0 right-0 w-full md:h-[74px] h-[56px] ${props}`}
      >
        <div className="container mx-auto h-full">
          <div className="header-main flex justify-between h-full">
            <div
              className="menu-mobile-icon lg:hidden flex items-center"
              onClick={handleMenuMobile}
            >
              <i className="icon-category text-2xl"></i>
            </div>
            <div className="left flex items-center gap-16">
              <a
                href={"/"}
                className="flex items-center max-lg:absolute max-lg:left-1/2 max-lg:-translate-x-1/2"
              >
                <div className="heading4">Kissaria</div>
              </a>
              <div className="menu-main h-full max-lg:hidden">
                <ul className="flex items-center gap-8 h-full">
                  <li className="h-full relative">
                    <a
                      href="#!"
                      className={`text-button-uppercase duration-300 h-full flex items-center justify-center gap-1 ${
                        pathname === "/" ? "active" : ""
                      }`}
                    >
                      Demo
                    </a>
                    <div className="sub-menu py-3 px-5 -left-10 w-max absolute grid grid-cols-4 gap-5 bg-white rounded-b-xl">
                      <ul>
                        <li>
                          <a
                            href="/"
                            className={`link text-secondary duration-300 ${
                              pathname === "/" ? "active" : ""
                            }`}
                          >
                            Home Fashion 1
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion2"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 2
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion3"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 3
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion4"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 4
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion5"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 5
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion6"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 6
                          </a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <a
                            href="/homepages/fashion7"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 7
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion8"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 8
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion9"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 9
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion10"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 10
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/fashion11"
                            className="link text-secondary duration-300"
                          >
                            Home Fashion 11
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/underwear"
                            className="link text-secondary duration-300"
                          >
                            Home Underwear
                          </a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <a
                            href="/homepages/cosmetic1"
                            className="link text-secondary duration-300"
                          >
                            Home Cosmetic 1
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/cosmetic2"
                            className="link text-secondary duration-300"
                          >
                            Home Cosmetic 2
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/cosmetic3"
                            className="link text-secondary duration-300"
                          >
                            Home Cosmetic 3
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/pet"
                            className="link text-secondary duration-300"
                          >
                            Home Pet Store
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/jewelry"
                            className="link text-secondary duration-300"
                          >
                            Home Jewelry
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/furniture"
                            className="link text-secondary duration-300"
                          >
                            Home Furniture
                          </a>
                        </li>
                      </ul>
                      <ul>
                        <li>
                          <a
                            href="/homepages/watch"
                            className="link text-secondary duration-300"
                          >
                            Home Watch
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/toys"
                            className="link text-secondary duration-300"
                          >
                            Home Toys Kid
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/yoga"
                            className="link text-secondary duration-300"
                          >
                            Home Yoga
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/organic"
                            className="link text-secondary duration-300"
                          >
                            Home Organic
                          </a>
                        </li>
                        <li>
                          <a
                            href="/homepages/marketplace"
                            className="text-secondary duration-300"
                          >
                            Home Marketplace
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="h-full">
                    <a
                      href="#!"
                      className="text-button-uppercase duration-300 h-full flex items-center justify-center"
                    >
                      Features
                    </a>
                    <div className="mega-menu absolute top-[74px] left-0 bg-white w-screen">
                      <div className="container">
                        <div className="flex justify-between py-8">
                          <div className="nav-link basis-2/3 grid grid-cols-4 gap-y-8">
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                For Men
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleGenderClick("men")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Starting From 50% Off
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("outerwear")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Outerwear | Coats
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("sweater")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Sweaters | Cardigans
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("shirt")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Shirt | Sweatshirts
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleGenderClick("men")}
                                    className={`link text-secondary duration-300 cursor-pointer view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Massimo Dutti
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("shirt")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Shirt | Clothes
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("top")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Top | Overshirts
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("t-shirt")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    T-shirts | Clothes
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("swimwear")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Swimwear | Underwear
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleCategoryClick("fashion")
                                    }
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Skincare
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("face")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Faces Skin
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("eye")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Eyes Makeup
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("lip")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Lip Polish
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("hair")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Hair Care
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleCategoryClick("cosmetic")
                                    }
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Health
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("candle")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Cented Candle
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("drinks")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Health Drinks
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("clothes")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Yoga Clothes
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("mats")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Yoga Equipment
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleCategoryClick("yoga")}
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                For Women
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleGenderClick("women")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Starting From 60% Off
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("dress")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Dresses | Jumpsuits
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("t-shirt")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    T-shirts | Sweatshirts
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleTypeClick("accessories")
                                    }
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Accessories | Jewelry
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleGenderClick("women")}
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                For Kid
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("bed")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Kids Bed
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("toy")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Boy{String.raw`'s`} Toy
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("blanket")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Baby Blanket
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("clothing")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Newborn Clothing
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleCategoryClick("toys-kid")
                                    }
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                For Home
                              </div>
                              <ul>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleCategoryClick("furniture")
                                    }
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Furniture | Decor
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("table")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Table | Living Room
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("chair")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Chair | Work Room
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() => handleTypeClick("lighting")}
                                    className={`link text-secondary duration-300 cursor-pointer`}
                                  >
                                    Lighting | Bed Room
                                  </div>
                                </li>
                                <li>
                                  <div
                                    onClick={() =>
                                      handleCategoryClick("furniture")
                                    }
                                    className={`link text-secondary duration-300 view-all-btn`}
                                  >
                                    View All
                                  </div>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="banner-ads-block pl-2.5 basis-1/3">
                            <div
                              className="banner-ads-item bg-linear rounded-2xl relative overflow-hidden cursor-pointer"
                              onClick={() => handleTypeClick("swimwear")}
                            >
                              <div className="text-content py-14 pl-8 relative z-[1]">
                                <div className="text-button-uppercase text-white bg-red px-2 py-0.5 inline-block rounded-sm">
                                  Save $10
                                </div>
                                <div className="heading6 mt-2">
                                  Dive into Savings <br />
                                  on Swimwear
                                </div>
                                <div className="body1 mt-3 text-secondary">
                                  Starting at{" "}
                                  <span className="text-red">$59.99</span>
                                </div>
                              </div>
                              <img
                                src={require("../../../images/slider/bg2-2.png")}
                                width={200}
                                height={100}
                                alt="bg-img"
                                className="basis-1/3 absolute right-0 top-0 duration-700"
                              />
                            </div>
                            <div
                              className="banner-ads-item bg-linear rounded-2xl relative overflow-hidden cursor-pointer mt-8"
                              onClick={() => handleTypeClick("accessories")}
                            >
                              <div className="text-content py-14 pl-8 relative z-[1]">
                                <div className="text-button-uppercase text-white bg-red px-2 py-0.5 inline-block rounded-sm">
                                  Save $10
                                </div>
                                <div className="heading6 mt-2">
                                  20% off <br />
                                  accessories
                                </div>
                                <div className="body1 mt-3 text-secondary">
                                  Starting at{" "}
                                  <span className="text-red">$59.99</span>
                                </div>
                              </div>
                              <img
                                src={require("../../../images/other/bg-feature.png")}
                                width={200}
                                height={100}
                                alt="bg-img"
                                className="basis-1/3 absolute right-0 top-0 duration-700"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="h-full">
                    <a
                      href="#!"
                      className={`text-button-uppercase duration-300 h-full flex items-center justify-center ${
                        pathname.includes("/shop/") ? "active" : ""
                      }`}
                    >
                      Shop
                    </a>
                    <div className="mega-menu absolute top-[74px] left-0 bg-white w-screen">
                      <div className="container">
                        <div className="flex justify-between py-8">
                          <div className="nav-link basis-2/3 flex justify-between pr-12">
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Shop Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb-img"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb-img"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb IMG
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb1"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb1"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb 1
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb2"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb2"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb 2
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/collection"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/collection"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Collection
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Shop Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/filter-canvas"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-canvas"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Canvas
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/filter-options"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-options"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Options
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/filter-dropdown"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-dropdown"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Dropdown
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/sidebar-list"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/sidebar-list"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Sidebar List
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Shop Layout
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/default"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/default-grid"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default-grid"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default Grid
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/default-list"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default-list"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default List
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/fullwidth"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/fullwidth"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Full Width
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/square"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/square"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Square
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/checkout"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/checkout" ? "active" : ""
                                    }`}
                                  >
                                    Checkout
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/checkout2"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/checkout2" ? "active" : ""
                                    }`}
                                  >
                                    Checkout Style 2
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Products Pages
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/wishlist"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/wishlist" ? "active" : ""
                                    }`}
                                  >
                                    Wish List
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/search-result"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/search-result"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Search Result
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/cart"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/cart" ? "active" : ""
                                    }`}
                                  >
                                    Shopping Cart
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/login"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/login" ? "active" : ""
                                    }`}
                                  >
                                    Login/Register
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/forgot-password"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/forgot-password"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Forgot Password
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/order-tracking"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/order-tracking"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Order Tracking
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/my-account"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/my-account" ? "active" : ""
                                    }`}
                                  >
                                    My Account
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="recent-product pl-2.5 basis-1/3">
                            <div className="text-button-uppercase pb-2">
                              Recent Products
                            </div>
                            <div className="list-product hide-product-sold  grid grid-cols-2 gap-5 mt-3">
                              {productData
                                .filter((item) => item.action === "add to cart")
                                .slice(0, 2)
                                .map((prd, index) => (
                                  <Product key={index} data={prd} type="grid" />
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="h-full">
                    <a
                      href="#!"
                      className={`text-button-uppercase duration-300 h-full flex items-center justify-center ${
                        pathname.includes("/product/") ? "active" : ""
                      }`}
                    >
                      Product
                    </a>
                    <div className="mega-menu absolute top-[74px] left-0 bg-white w-screen">
                      <div className="container">
                        <div className="flex justify-between py-8">
                          <div className="nav-link basis-2/3 flex justify-between xl:pr-14 pr-5">
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Products Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/" ? "active" : ""
                                    }`}
                                  >
                                    Products Defaults
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/sale"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/sale"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Sale
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/countdown-timer"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/countdown-timer"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Countdown Timer
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/grouped"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/grouped"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grouped
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/bought-together"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/bought-together"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Frequently Bought Together
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/out-of-stock"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/out-of-stock"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Out Of Stock
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/variable"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/variable"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Variable
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Products Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/external"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/external"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products External
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/on-sale"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/on-sale"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products On Sale
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/discount"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/discount"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products With Discount
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/sidebar"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/sidebar"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products With Sidebar
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/fixed-price"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/fixed-price"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Fixed Price
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-2">
                                Products Layout
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/thumbnail-left"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/thumbnail-left"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Thumbnails Left
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/thumbnail-bottom"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/thumbnail-bottom"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Thumbnails Bottom
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/one-scrolling"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/one-scrolling"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grid 1 Scrolling
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/two-scrolling"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/two-scrolling"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grid 2 Scrolling
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/combined-one"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/combined-one"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Combined 1
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/combined-two"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/product/combined-two"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Combined 2
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="recent-product pl-2.5 basis-1/3">
                            <div className="text-button-uppercase pb-2">
                              Recent Products
                            </div>
                            <div className="list-product hide-product-sold  grid grid-cols-2 gap-5 mt-3">
                              {productData
                                .filter((item) => item.action === "add to cart")
                                .slice(0, 2)
                                .map((prd, index) => (
                                  <Product key={index} data={prd} type="grid" />
                                ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="h-full relative">
                    <a
                      href="#!"
                      className={`text-button-uppercase duration-300 h-full flex items-center justify-center ${
                        pathname.includes("/blog") ? "active" : ""
                      }`}
                    >
                      Blog
                    </a>
                    <div className="sub-menu py-3 px-5 -left-10 absolute bg-white rounded-b-xl">
                      <ul className="w-full">
                        <li>
                          <a
                            href="/blog/default"
                            className={`link text-secondary duration-300 ${
                              pathname === "/blog/default" ? "active" : ""
                            }`}
                          >
                            Blog Default
                          </a>
                        </li>
                        <li>
                          <a
                            href="/blog/list"
                            className={`link text-secondary duration-300 ${
                              pathname === "/blog/list" ? "active" : ""
                            }`}
                          >
                            Blog List
                          </a>
                        </li>
                        <li>
                          <a
                            href="/blog/grid"
                            className={`link text-secondary duration-300 ${
                              pathname === "/blog/grid" ? "active" : ""
                            }`}
                          >
                            Blog Grid
                          </a>
                        </li>
                        <li>
                          <a
                            href="/blog/detail1"
                            className={`link text-secondary duration-300 ${
                              pathname === "/blog/detail1" ? "active" : ""
                            }`}
                          >
                            Blog Detail 1
                          </a>
                        </li>
                        <li>
                          <a
                            href="/blog/detail2"
                            className={`link text-secondary duration-300 ${
                              pathname === "/blog/detail2" ? "active" : ""
                            }`}
                          >
                            Blog Detail 2
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="h-full relative">
                    <a
                      href="#!"
                      className={`text-button-uppercase duration-300 h-full flex items-center justify-center ${
                        pathname.includes("/pages") ? "active" : ""
                      }`}
                    >
                      Pages
                    </a>
                    <div className="sub-menu py-3 px-5 -left-10 absolute bg-white rounded-b-xl">
                      <ul className="w-full">
                        <li>
                          <a
                            href="/pages/about"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/about" ? "active" : ""
                            }`}
                          >
                            About Us
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/contact"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/contact" ? "active" : ""
                            }`}
                          >
                            Contact Us
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/store-list"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/store-list" ? "active" : ""
                            }`}
                          >
                            Store List
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/page-not-found"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/page-not-found"
                                ? "active"
                                : ""
                            }`}
                          >
                            404
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/faqs"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/faqs" ? "active" : ""
                            }`}
                          >
                            FAQs
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/coming-soon"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/coming-soon" ? "active" : ""
                            }`}
                          >
                            Coming Soon
                          </a>
                        </li>
                        <li>
                          <a
                            href="/pages/customer-feedbacks"
                            className={`link text-secondary duration-300 ${
                              pathname === "/pages/customer-feedbacks"
                                ? "active"
                                : ""
                            }`}
                          >
                            Customer Feedbacks
                          </a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="right flex gap-12">
              <div className="max-md:hidden search-icon flex items-center cursor-pointer relative">
                <Icon.MagnifyingGlass
                  size={24}
                  color="black"
                  onClick={openModalSearch}
                />
                <div className="line absolute bg-line w-px h-6 -right-6"></div>
              </div>
              <div className="list-action flex items-center gap-4">
                <div className="user-icon flex items-center justify-center cursor-pointer">
                  <Icon.User
                    size={24}
                    color="black"
                    onClick={handleLoginPopup}
                  />
                  <div
                    className={`login-popup absolute top-[74px] w-[320px] p-7 rounded-xl bg-white box-shadow-small 
                                            ${openLoginPopup ? "open" : ""}`}
                  >
                    <a
                      href={"/login"}
                      className="button-main w-full text-center"
                    >
                      Login
                    </a>
                    <div className="text-secondary text-center mt-3 pb-4">
                      Don’t have an account?
                      <a
                        href={"/register"}
                        className="text-black pl-1 hover:underline"
                      >
                        Register
                      </a>
                    </div>
                    <div className="bottom pt-4 border-t border-line"></div>
                    <a href={"#!"} className="body1 hover:underline">
                      Support
                    </a>
                  </div>
                </div>
                <div
                  className="max-md:hidden wishlist-icon flex items-center cursor-pointer"
                  onClick={openModalWishlist}
                >
                  <Icon.Heart size={24} color="black" />
                </div>
                <div
                  className="cart-icon flex items-center relative cursor-pointer"
                  onClick={openModalCart}
                >
                  <Icon.Handbag size={24} color="black" />
                  <span className="quantity cart-quantity absolute -right-1.5 -top-1.5 text-xs text-white bg-black w-4 h-4 flex items-center justify-center rounded-full">
                    {cartState.cartArray.length}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div id="menu-mobile" className={`${openMenuMobile ? "open" : ""}`}>
        <div className="menu-container bg-white h-full">
          <div className="container h-full">
            <div className="menu-main h-full overflow-hidden">
              <div className="heading py-2 relative flex items-center justify-center">
                <div
                  className="close-menu-mobile-btn absolute left-0 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-surface flex items-center justify-center"
                  onClick={handleMenuMobile}
                >
                  <Icon.X size={14} />
                </div>
                <a
                  href={"/"}
                  className="logo text-3xl font-semibold text-center"
                >
                  Kissaria
                </a>
              </div>
              <div className="form-search relative mt-2">
                <Icon.MagnifyingGlass
                  size={20}
                  className="absolute left-3 top-1/2 -translate-y-1/2 cursor-pointer"
                />
                <input
                  type="text"
                  placeholder="Rechercher un article..."
                  className=" h-12 rounded-lg border border-line text-sm w-full pl-10 pr-4"
                />
              </div>
              <div className="list-nav mt-6">
                <ul>
                  <li
                    className={`${openSubNavMobile === 1 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(1)}
                  >
                    <a
                      href={"#!"}
                      className={`text-xl font-semibold flex items-center justify-between`}
                    >
                      Demo
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(1)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full grid grid-cols-2 pt-2 pb-6">
                        <ul>
                          <li>
                            <a
                              href="/"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/" ? "active" : ""
                              }`}
                            >
                              Home Fashion 1
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion2"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion2"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 2
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion3"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion3"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 3
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion4"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion4"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 4
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion5"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion5"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 5
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion6"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion6"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 6
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion7"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion7"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 7
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion8"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion8"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 8
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion9"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion9"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 9
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion10"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion10"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 10
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/fashion11"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/fashion11"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Fashion 11
                            </a>
                          </li>
                        </ul>
                        <ul>
                          <li>
                            <a
                              href="/homepages/underwear"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/underwear"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Underwear
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/cosmetic1"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/cosmetic1"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Cosmetic 1
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/cosmetic2"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/cosmetic2"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Cosmetic 2
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/cosmetic3"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/cosmetic3"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Cosmetic 3
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/pet"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/pet" ? "active" : ""
                              }`}
                            >
                              Home Pet Store
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/jewelry"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/jewelry"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Jewelry
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/furniture"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/furniture"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Furniture
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/watch"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/watch" ? "active" : ""
                              }`}
                            >
                              Home Watch
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/toys"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/toys" ? "active" : ""
                              }`}
                            >
                              Home Toys Kid
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/yoga"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/yoga" ? "active" : ""
                              }`}
                            >
                              Home Yoga
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/organic"
                              className={`nav-item-mobile link text-secondary duration-300 ${
                                pathname === "/homepages/organic"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Organic
                            </a>
                          </li>
                          <li>
                            <a
                              href="/homepages/marketplace"
                              className={`nav-item-mobile text-secondary duration-300 ${
                                pathname === "/homepages/marketplace"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Home Marketplace
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`${openSubNavMobile === 2 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(2)}
                  >
                    <a
                      href={"#!"}
                      className="text-xl font-semibold flex items-center justify-between mt-5"
                    >
                      Features
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(2)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full pt-3 pb-12">
                        <div className="nav-link grid grid-cols-2 gap-5 gap-y-6">
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              For Men
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() => handleGenderClick("men")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Starting From 50% Off
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("outerwear")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Outerwear | Coats
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("sweater")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Sweaters | Cardigans
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("shirt")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Shirt | Sweatshirts
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleGenderClick("men")}
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              Skincare
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("face")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Faces Skin
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("eye")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Eyes Makeup
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("lip")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Lip Polish
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("hair")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Hair Care
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() =>
                                    handleCategoryClick("cosmetic")
                                  }
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              Health
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("candle")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Cented Candle
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("drinks")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Health Drinks
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("clothes")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Yoga Clothes
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("mats")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Yoga Equipment
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleCategoryClick("yoga")}
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              For Women
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() => handleGenderClick("women")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Starting From 60% Off
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("dress")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Dresses | Jumpsuits
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("t-shirt")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  T-shirts | Sweatshirts
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("accessories")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Accessories | Jewelry
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleGenderClick("women")}
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              For Kid
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("bed")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Kids Bed
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("toy")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Boy{String.raw`'s`} Toy
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("blanket")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Baby Blanket
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("clothing")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Newborn Clothing
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() =>
                                    handleCategoryClick("toys-kid")
                                  }
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div className="nav-item">
                            <div className="text-button-uppercase pb-1">
                              For Home
                            </div>
                            <ul>
                              <li>
                                <div
                                  onClick={() =>
                                    handleCategoryClick("furniture")
                                  }
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Furniture | Decor
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("table")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Table | Living Room
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("chair")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Chair | Work Room
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() => handleTypeClick("lighting")}
                                  className={`link text-secondary duration-300 cursor-pointer`}
                                >
                                  Lighting | Bed Room
                                </div>
                              </li>
                              <li>
                                <div
                                  onClick={() =>
                                    handleCategoryClick("furniture")
                                  }
                                  className={`link text-secondary duration-300 view-all-btn`}
                                >
                                  View All
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="banner-ads-block grid sm:grid-cols-2 items-center gap-6 pt-6">
                          <div
                            className="banner-ads-item bg-linear rounded-2xl relative overflow-hidden"
                            onClick={() => handleTypeClick("swimwear")}
                          >
                            <div className="text-content py-14 pl-8 relative z-[1]">
                              <div className="text-button-uppercase text-white bg-red px-2 py-0.5 inline-block rounded-sm">
                                Save $10
                              </div>
                              <div className="heading6 mt-2">
                                Dive into Savings <br />
                                on Swimwear
                              </div>
                              <div className="body1 mt-3 text-secondary">
                                Starting at{" "}
                                <span className="text-red">$59.99</span>
                              </div>
                            </div>
                            <img
                              src={require("../../../images/slider/bg2-2.png")}
                              width={200}
                              height={100}
                              alt="bg-img"
                              className="basis-1/3 absolute right-0 top-0"
                            />
                          </div>
                          <div
                            className="banner-ads-item bg-linear rounded-2xl relative overflow-hidden"
                            onClick={() => handleTypeClick("accessories")}
                          >
                            <div className="text-content py-14 pl-8 relative z-[1]">
                              <div className="text-button-uppercase text-white bg-red px-2 py-0.5 inline-block rounded-sm">
                                Save $10
                              </div>
                              <div className="heading6 mt-2">
                                20% off <br />
                                accessories
                              </div>
                              <div className="body1 mt-3 text-secondary">
                                Starting at{" "}
                                <span className="text-red">$59.99</span>
                              </div>
                            </div>
                            <img
                              src={require("../../../images/other/bg-feature.png")}
                              width={200}
                              height={100}
                              alt="bg-img"
                              className="basis-1/3 absolute right-0 top-0"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`${openSubNavMobile === 3 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(3)}
                  >
                    <a
                      href={"#!"}
                      className="text-xl font-semibold flex items-center justify-between mt-5"
                    >
                      Shop
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(3)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full pt-3 pb-12">
                        <div className="">
                          <div className="nav-link grid grid-cols-2 gap-5 gap-y-6 justify-between">
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Shop Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb-img"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb-img"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb IMG
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb1"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb1"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb 1
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/breadcrumb2"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/breadcrumb2"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Breadcrumb 2
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/collection"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/collection"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Collection
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Shop Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/filter-canvas"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-canvas"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Canvas
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/filter-options"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-options"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Options
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/filter-dropdown"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/filter-dropdown"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Filter Dropdown
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/sidebar-list"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/sidebar-list"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Sidebar List
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Shop Layout
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/shop/default"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/default-grid"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default-grid"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default Grid
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/default-list"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/default-list"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Default List
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/fullwidth"}
                                    className={`link text-secondary duration-300 cursor-pointer ${
                                      pathname === "/shop/fullwidth"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Full Width
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/shop/square"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/shop/square"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Shop Square
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/checkout"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/checkout" ? "active" : ""
                                    }`}
                                  >
                                    Checkout
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/checkout2"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/checkout2" ? "active" : ""
                                    }`}
                                  >
                                    Checkout Style 2
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Products Pages
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/wishlist"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/wishlist" ? "active" : ""
                                    }`}
                                  >
                                    Wish List
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/search-result"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/search-result"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Search Result
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/cart"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/cart" ? "active" : ""
                                    }`}
                                  >
                                    Shopping Cart
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/login"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/login" ? "active" : ""
                                    }`}
                                  >
                                    Login/Register
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/forgot-password"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/forgot-password"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Forgot Password
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/order-tracking"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/order-tracking"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Order Tracking
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/my-account"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/my-account" ? "active" : ""
                                    }`}
                                  >
                                    My Account
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="recent-product pt-3">
                            <div className="text-button-uppercase pb-1">
                              Recent Products
                            </div>
                            <div className="list-product hide-product-sold  grid grid-cols-2 gap-5 mt-3">
                              {productData.slice(0, 2).map((prd, index) => (
                                <Product key={index} data={prd} type="grid" />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`${openSubNavMobile === 4 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(4)}
                  >
                    <a
                      href={"#!"}
                      className="text-xl font-semibold flex items-center justify-between mt-5"
                    >
                      Product
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(4)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full pt-3 pb-12">
                        <div className="">
                          <div className="nav-link grid grid-cols-2 gap-5 gap-y-6 justify-between">
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Products Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/" ? "active" : ""
                                    }`}
                                  >
                                    Products Defaults
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/sale"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/sale"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Sale
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/countdown-timer"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/countdown-timer"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Countdown Timer
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/grouped"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/grouped"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grouped
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/bought-together"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/bought-together"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Frequently Bought Together
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/out-of-stock"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/out-of-stock"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Out Of Stock
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/variable"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/variable"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Variable
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item">
                              <div className="text-button-uppercase pb-1">
                                Products Features
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/external"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/external"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products External
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/on-sale"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/on-sale"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products On Sale
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/discount"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/discount"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products With Discount
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/sidebar"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/sidebar"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products With Sidebar
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/fixed-price"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/fixed-price"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Fixed Price
                                  </a>
                                </li>
                              </ul>
                            </div>
                            <div className="nav-item col-span-2">
                              <div className="text-button-uppercase pb-1">
                                Products Layout
                              </div>
                              <ul>
                                <li>
                                  <a
                                    href={"/product/thumbnail-left"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/thumbnail-left"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Thumbnails Left
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/thumbnail-bottom"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/thumbnail-bottom"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Thumbnails Bottom
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/one-scrolling"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/one-scrolling"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grid 1 Scrolling
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/two-scrolling"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/two-scrolling"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Grid 2 Scrolling
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/combined-one"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/combined-one"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Combined 1
                                  </a>
                                </li>
                                <li>
                                  <a
                                    href={"/product/combined-two"}
                                    className={`link text-secondary duration-300 ${
                                      pathname === "/product/combined-two"
                                        ? "active"
                                        : ""
                                    }`}
                                  >
                                    Products Combined 2
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div className="recent-product pt-4">
                            <div className="text-button-uppercase pb-1">
                              Recent Products
                            </div>
                            <div className="list-product hide-product-sold  grid grid-cols-2 gap-5 mt-3">
                              {productData.slice(0, 2).map((prd, index) => (
                                <Product key={index} data={prd} type="grid" />
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`${openSubNavMobile === 5 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(5)}
                  >
                    <a
                      href={"#!"}
                      className="text-xl font-semibold flex items-center justify-between mt-5"
                    >
                      Blog
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(5)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full pt-2 pb-6">
                        <ul className="w-full">
                          <li>
                            <a
                              href="/blog/default"
                              className={`link text-secondary duration-300 ${
                                pathname === "/blog/default" ? "active" : ""
                              }`}
                            >
                              Blog Default
                            </a>
                          </li>
                          <li>
                            <a
                              href="/blog/list"
                              className={`link text-secondary duration-300 ${
                                pathname === "/blog/list" ? "active" : ""
                              }`}
                            >
                              Blog List
                            </a>
                          </li>
                          <li>
                            <a
                              href="/blog/grid"
                              className={`link text-secondary duration-300 ${
                                pathname === "/blog/grid" ? "active" : ""
                              }`}
                            >
                              Blog Grid
                            </a>
                          </li>
                          <li>
                            <a
                              href="/blog/detail1"
                              className={`link text-secondary duration-300 ${
                                pathname === "/blog/detail1" ? "active" : ""
                              }`}
                            >
                              Blog Detail 1
                            </a>
                          </li>
                          <li>
                            <a
                              href="/blog/detail2"
                              className={`link text-secondary duration-300 ${
                                pathname === "/blog/detail2" ? "active" : ""
                              }`}
                            >
                              Blog Detail 2
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                  <li
                    className={`${openSubNavMobile === 6 ? "open" : ""}`}
                    onClick={() => handleOpenSubNavMobile(6)}
                  >
                    <a
                      href={"#!"}
                      className="text-xl font-semibold flex items-center justify-between mt-5"
                    >
                      Pages
                      <span className="text-right">
                        <Icon.CaretRight size={20} />
                      </span>
                    </a>
                    <div className="sub-nav-mobile">
                      <div
                        className="back-btn flex items-center gap-3"
                        onClick={() => handleOpenSubNavMobile(6)}
                      >
                        <Icon.CaretLeft />
                        Back
                      </div>
                      <div className="list-nav-item w-full pt-2 pb-6">
                        <ul className="w-full">
                          <li>
                            <a
                              href="/pages/about"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/about" ? "active" : ""
                              }`}
                            >
                              About Us
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/contact"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/contact" ? "active" : ""
                              }`}
                            >
                              Contact Us
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/store-list"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/store-list" ? "active" : ""
                              }`}
                            >
                              Store List
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/page-not-found"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/page-not-found"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              404
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/faqs"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/faqs" ? "active" : ""
                              }`}
                            >
                              FAQs
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/coming-soon"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/coming-soon"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Coming Soon
                            </a>
                          </li>
                          <li>
                            <a
                              href="/pages/customer-feedbacks"
                              className={`link text-secondary duration-300 ${
                                pathname === "/pages/customer-feedbacks"
                                  ? "active"
                                  : ""
                              }`}
                            >
                              Customer Feedbacks
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MenuOne;
